module.exports = __webpack_public_path__ + "img/EnGarde.5cd91156.jpg";